<template>
  <div class="ml-tip" v-show="open">
    <!-- Title -->
    <div class="ml-tip__header">
      <slot name="title"></slot>

      <img id="ml-tip__close" src="/static/img/icons/close.png" alt="Close" class="ml-tip__close" @click="close">
    </div>
    <!-- End of the title -->

    <div class="ml-tip__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      open: true
    }
  },

  methods: {
    close () {
      this.open = false
    }
  },

  mounted () {
    this.open = this.show
  },

  name: 'Tip',

  props: {
    show: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
@import "../styles/theme";
</style>




// WEBPACK FOOTER //
// src/components/Tip.vue